import { useLazyGetOptionListQuery } from '@app/main/api';
import { createEntireLoadOptionSource } from '@webinex/antik';
import { useMemo } from 'react';
import { FilterRule } from '@webinex/asky';

export interface UseOptionLookupSourceArgs {
  discriminator: string;
  archived?: boolean;
}

export function useOptionEntityOptionSource(args: UseOptionLookupSourceArgs) {
  const { discriminator, archived = false } = args;
  const [fetch, { currentData }] = useLazyGetOptionListQuery();

  return useMemo(
    () =>
      createEntireLoadOptionSource(() =>
        fetch(
          {
            discriminator,
            filterRule:
              archived !== undefined
                ? ({ operator: '=', fieldId: 'archived', value: archived } as FilterRule)
                : undefined,
          },
          true,
        )
          .unwrap()
          .then((result) => result.map((x) => ({ label: x.name, value: x.id }))),
      ),

    // eslint-disable-next-line react-hooks/exhaustive-deps
    [discriminator, currentData, fetch, archived],
  );
}
